import axios from 'axios';

function parseOrganizationParams(organization) {
  const parsedOrganization = Object.assign({}, organization);
  // replace all whitespaces
  if (organization.iban) parsedOrganization.iban = organization.iban.replace(/\s/g, '');
  if (organization.nip) parsedOrganization.nip = organization.nip.replace(/\s/g, '');

  return parsedOrganization;
}

export default {
  new(organization) {
    const params = parseOrganizationParams(organization);

    return axios.post('/organizations', params);
  },
  edit(organization) {
    const params = parseOrganizationParams(organization);

    return axios.patch(`/organizations/${organization.id}`, params);
  },
  submit(id) {
    return axios.post(`/organizations/${id}/submit`);
  },
  getOrganizations(succ) {
    axios.get('/organizations/').then((response) => {
      succ(response.data);
    });
  },
  createKYCDocument(documentType) {
    return axios.post('/legal_users/create_document', { type: documentType });
  },
  addKYCDocumentPages(documentId, pages) {
    return axios.post('/legal_users/add_pages',
      {
        kyc_document: {
          document_id: documentId,
          pages,
        },
      },
    );
  },
  submitKYCDocument(documentId) {
    return axios.patch('legal_users/submit_document', { document_id: documentId });
  },
  listDocuments(succ) {
    return axios.get('legal_users/list_documents').then((response) => {
      succ(response.data);
    });
  },
  checkLegalUser() {
    return axios.get('legal_users');
  },
  createMangopayOrganization(formData) {
    return axios.post('legal_users', formData);
  },
  // FIXME There is some issue with this endpoint on mangopay side - address objects are not updated
  // even though request is correct, other params are updated properly
  updateMangopayOrganization(formData) {
    return axios.patch('legal_users', formData);
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/organizations.js